import { IHistoricalSnapshotDto } from "../../interface/dto/historical-snapshots.dto";
import {
    HistoricalSnapshotActionType,
    IHistoricalSnapshotAction,
} from "./historical-snapshots.actions";

export interface IHistoricalSnapshotState {
    isLoading: boolean;
    error?: string;
    snapshots?: Array<IHistoricalSnapshotDto>;
}

const initState: IHistoricalSnapshotState = {
    isLoading: false,
    snapshots: undefined,
};

export const historicalSnapshotsReducer = (
    state = initState,
    action: IHistoricalSnapshotAction,
) => {
    switch (action.type) {
        case HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET:
            return {
                ...state,
                isLoading: true,
                error: undefined,
                snapshots: undefined,
            };
        case HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET_ERROR:
            return { ...state, error: action.payload.error, isLoading: false };
        case HistoricalSnapshotActionType.HISTORICAL_SNAPSHOT_GET_SUCCESS:
            return {
                ...state,
                snapshots: action.payload.historicalSnapshot
                    ?.sort((a, b) => b.date.localeCompare(a.date))
                    .map((snapshot) => ({
                        ...snapshot,
                        country: snapshot.country ?? [],
                    })),
                isLoading: false,
            };
        default:
            return state;
    }
};
